import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const OverviewReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default OverviewReport
